/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

import { ref, onBeforeUnmount, type Ref } from 'vue';

export function useIsUnmounted(): Ref<boolean> {
	const isUnmounted = ref( false );

	onBeforeUnmount( () => {
		isUnmounted.value = true;
	} );

	return isUnmounted;
}
